<template>
    <!-- Future -->
    <section class="wheel bg-indigo-900 text-white my-12 overflow-hidden">
        <div class="container grid grid-cols-1 lg:grid-cols-2 items-center gap-8">
            <!-- Text -->
            <div class="flex flex-col gap-8 py-12 lg:py-24">
                <h2 class="landing-h2">
                    <template v-for="currentBlok in blok.headline">
                        <span :class="[currentBlok.hasColorGradient ? 'gradient-light' : '']">{{ currentBlok.text }}&nbsp;</span> 
                    </template>
                </h2>
                <div class="space-y-4">
                    <p class="subtitle">{{ blok.subtitle }}</p>
                    <p v-for="point in blok.paragraph" class="text-base">{{ point.textarea }}</p>
                </div>
                <div>
                    <a href="#hero-form-coisar" class="btn-primary">{{ blok.button }}</a>
                </div>
            </div>
            <!-- Wheel -->
            <div class="relative lg:w-[110%] lg:h-[110%] -mb-48 lg:mb-0">
                <img class="wheel-img" :style="{ '--rot': rotation + 'deg' }" :alt="blok.image?.alt" :src="blok.image?.filename">
            </div>
        </div>
    </section>
</template>

<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'
    defineProps({ blok: Object })

    // Rotation in Grad
    const rotation = ref(0)

    // Funktion, die beim Scrollen aufgerufen wird
    const handleScroll = () => {
      // Beispiel-Faktor: 0.2 Grad pro Pixel Scroll
      rotation.value = window.scrollY * 0.05
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })
</script>
<style scoped>
/* Bild rotieren und ab lg vertikal zentrieren */
.wheel-img {
  /* Basis: nur Rotation (kein TranslateY) */
  transform: rotate(var(--rot));
  /* Damit die transform-Eigenschaft überhaupt greift */
  transform-origin: center center;
}

@media (min-width: 1024px) {
  .wheel-img {
    /* Ab lg: Bild absolut positionieren, vertikal zentrieren */
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%) rotate(var(--rot));
    /* Höhe passt sich der Eltern-Container-Höhe an */
    width: auto !important;
    height: 100% !important;
    max-width: none;
  }
}
</style>